import { Paper } from '@mantine/core';
import classNames from 'classnames/bind';
import { PageTitle } from 'components/PageTitle';
import { Right } from 'components/Right';
import { SaveButton } from 'components/SaveButton';
import { tKeys, useTranslation } from 'locales';
import type { PropsWithChildren } from 'react';
import GradientBorder from 'shared/components/GradientBorder';

import { useInvoiceFormContext } from './InvoiceForm.context';
import styleIdentifiers from './InvoiceForm.module.scss';
import type { InvoiceFormProps, InvoiceFormSharedProps } from './InvoiceForm.types';

const styles = classNames.bind(styleIdentifiers);

type InvoiceFormContainerProps = InvoiceFormProps & InvoiceFormSharedProps;

export const InvoiceFormContainer = ({
  submit,
  isCreditNote,
  invoice,
  creditNote,
  children,
}: PropsWithChildren<InvoiceFormContainerProps>) => {
  const { t } = useTranslation();

  const form = useInvoiceFormContext();

  const getTitle = () => {
    if (isCreditNote)
      return t(creditNote ? tKeys.INVOICING.CREATE.EDIT_CREDIT_NOTE : tKeys.NEW_CREDIT_NOTE);
    return t(invoice ? tKeys.INVOICING.EDIT_INVOICE : tKeys.NEW_INVOICE);
  };

  return (
    <form className={styles('InvoiceForm')} onSubmit={form.onSubmit(submit)}>
      <PageTitle>
        {getTitle()}
        <PageTitle.Actions>
          <SaveButton type="submit" />
        </PageTitle.Actions>
      </PageTitle>
      <Paper radius="sm" shadow="sm" mb={20} p={0} style={{ overflow: 'hidden' }}>
        <GradientBorder />
        <div className={styles('content')}>{children}</div>
        <GradientBorder bottom />
      </Paper>
      <Right>
        <SaveButton type="submit" />
      </Right>
    </form>
  );
};
